import React from "react";

const LeadershipMessage = () => {
  return (
    <>
      {/* Page Styles */}
      <style>
        {`
          @keyframes gradientMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }

          @keyframes float {
            0%, 100% { transform: translateY(0px) translateX(0px); }
            33% { transform: translateY(-20px) translateX(10px); }
            66% { transform: translateY(10px) translateX(-10px); }
          }

          .leadership-page {
            position: relative;
            background: linear-gradient(-45deg, #000000, #0a0a0a, #1a0a1a, #0a1a2a);
            background-size: 400% 400%;
            animation: gradientMove 15s ease infinite;
            min-height: 100vh;
            padding: 90px 20px;
            color: #fff;
            font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
            overflow: hidden;
          }

          .leadership-page::before {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background-image: 
              radial-gradient(circle at 20% 30%, rgba(96, 165, 250, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(236, 72, 153, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 40% 80%, rgba(167, 139, 250, 0.08) 0%, transparent 50%);
            animation: float 20s ease-in-out infinite;
            pointer-events: none;
          }

          .leadership-page::after {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background-image: 
              repeating-linear-gradient(
                0deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              ),
              repeating-linear-gradient(
                90deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              );
            pointer-events: none;
          }

          .leadership-container {
            max-width: 1100px;
            margin: auto;
            position: relative;
            z-index: 1;
          }

          .leadership-title {
            text-align: center;
            font-size: 44px;
            font-weight: 700;
            margin-bottom: 25px;
            letter-spacing: 1px;
            background: linear-gradient(135deg, #60a5fa, #ec4899, #a78bfa, #60a5fa);
            background-size: 300% 300%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: gradientMove 8s ease infinite;
          }

          .leadership-intro {
            text-align: justify;
            max-width: 900px;
            margin: 0 auto 70px;
            font-size: 17px;
            line-height: 1.8;
            color: #cbd5e1;
          }

          .leader-card {
            background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
            padding: 45px;
            border-radius: 16px;
            margin-bottom: 50px;
            box-shadow: 0 25px 50px rgba(0, 0, 0, 0.7);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .leader-card:hover {
            transform: translateY(-6px);
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.9);
          }

          .leader-name {
            font-size: 30px;
            font-weight: 600;
            margin-bottom: 6px;
            background: linear-gradient(135deg, #60a5fa, #ec4899, #a78bfa);
            background-size: 200% 200%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: gradientMove 8s ease infinite;
          }

          .leader-role {
            display: block;
            font-size: 15px;
            color: #9ca3af;
            margin-bottom: 22px;
          }

          .leader-card p {
            font-size: 16.5px;
            line-height: 1.9;
            color: #d1d5db;
            margin-bottom: 18px;
          }

          @media (max-width: 768px) {
            .leadership-title { font-size: 34px; }
            .leader-card { padding: 30px; }
          }
        `}
      </style>

      {/* Page Content */}
      <section className="leadership-page">
        <div className="leadership-container">
          <h1 className="leadership-title">Leadership Message</h1>

          <p className="leadership-intro">
            At Zyntro Software Solutions Private Limited, our leadership team is driven by vision, integrity, and a commitment
            to delivering long-term value. Based in the historic city of Varanasi, we blend tradition with innovation to create cutting-edge IT solutions. We believe strong leadership builds
            trust, fuels innovation, and shapes sustainable growth in the ever-evolving technology landscape. Our directors lead by example and ensure that every project aligns with our values of excellence and client satisfaction.
          </p>

          {/* Rishabh Singh */}
          <div className="leader-card">
            <h2 className="leader-name">Rishabh Singh</h2>
            <span className="leader-role">Director</span>

            <p>
              As Director at Zyntro Software Solutions, Rishabh Singh provides strategic vision and oversight to drive organizational excellence and innovation. He is committed to building lasting relationships with clients and partners while fostering a culture of transparency, integrity, and continuous improvement.
            </p>

            <p>
              Rishabh's leadership focuses on leveraging cutting-edge technologies and talent to deliver transformative solutions that create sustainable value. His unwavering commitment to ethical business practices and operational excellence ensures Zyntro remains a trusted industry leader both in India and on the global stage.
            </p>
          </div>

          {/* Sunny Singh */}
          <div className="leader-card">
            <h2 className="leader-name">Sunny Singh</h2>
            <span className="leader-role">Director</span>

            <p>
              As Director at Zyntro Software Solutions, Sunny Singh brings strategic expertise and operational acumen to guide the company's growth trajectory. He plays a pivotal role in translating vision into actionable strategies while maintaining the highest standards of execution and client satisfaction.
            </p>

            <p>
              Sunny is passionate about empowering teams, fostering innovation, and building sustainable partnerships that drive mutual success. His leadership philosophy centers on combining local insights with global best practices to deliver reliable, future-ready IT solutions that make a tangible difference in our clients' digital transformation journeys.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default LeadershipMessage;